import { http, HttpResponse } from 'msw';
import { env } from '@repo/env';
import { loanSignVerifyMock } from './mocks/loan-sign-verify.mock';
var apiUrl = env.VITE_API_URL;
export var loanSignVerifyHandler = [
    http.post("".concat(apiUrl, "/loan/sign/verify"), function () {
        return HttpResponse.json(loanSignVerifyMock.success);
    }),
];
